export class FcuUnitNetwork {
    id: string;
    vesselId: string;
    fcuId: string;
    networkType: FcuNetworkType;
    LineAIp: string;
    LineBIp: string;
    fieldNetLineAIp: string;
    fieldNetLineBIp: string;
    ceuCommLineAIp: string;
    ceuCommLineBIp: string;
}

export const fcuNetwork = {
    A: 'A',
    B: 'B',
    Multicasting: 'Multicasting',
} as const;

export type FcuNetworkType = (typeof fcuNetwork)[keyof typeof fcuNetwork];

export const defaultMulticastingIp = {
    LineAIp: '239.192.168',
    LineBIp: '239.192.168',
};
